import { toast } from "react-toastify";
import NProgress from 'nprogress';
import axiosInstance from "../../../../../axiosInstance";
import { HRMS_ATS_API_URL } from "../../../../Constants/baseConstant";
import { getDomain, getUserId } from "../../../Base/helper/baseFunctions";

export const GetCandidateSourceHelper = async (params) => {
    NProgress.start();
    return await axiosInstance(`/ats/ancillary/getCandidateSource`, {
        method: "POST",
        baseURL: HRMS_ATS_API_URL,
        data: {
            domain_name: getDomain()
        }
    })
        .then((res) => {
            NProgress.done();
            return { message: "Success", hasError: false, data: res?.data };
        }).catch(err => {
            NProgress.done();
            return { message: "Error", hasError: true, data: err?.response?.data };
        });
};

export const UpsertCandidateSourceHelper = async (params) => {
    toast.dismiss();
    toast.info("Saving...");
    return await axiosInstance(`/ats/ancillary/upsertCandidateSource`, {
        method: "POST",
        baseURL: HRMS_ATS_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            source_name: params?.source_name,
            is_default: params?.is_default || false,
            candidate_source_configuration_pk: params?.candidate_source_configuration_pk || null
                   
        }
    })
        .then((res) => {
            toast.dismiss();
            toast.success( params?.candidate_source_configuration_pk ? "Candidate Source updated successfully" : "Candidate Source added successfully");
            return { message: "Success", hasError: false, data: res?.data };
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message);
            return { message: "Error", hasError: true, data: err?.response?.data };
        });
};


export const DeleteCandidateSourceHelper = async (params) => {
    toast.dismiss();
    toast.info("Deleting...");
    return await axiosInstance(`/ats/ancillary/deleteCandidateSource`, {
        method: "DELETE",
        baseURL: HRMS_ATS_API_URL,
        data: {
            domain_name: getDomain(),
            candidate_source_configuration_pk: params?.candidate_source_configuration_pk
        }
    })
        .then((res) => {
            toast.dismiss();
            toast.success("Candidate Source deleted successfully");
            return { message: "Success", hasError: false, data: res?.data };
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message);
            return { message: "Error", hasError: true, data: err?.response?.data };
        });
};
